import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { OrderFormFlagsSection } from './components/OrderFormFlagsSection';
import { OrderFormLineItemsSection } from './components/OrderFormLineItemsSection';
import { OrderFormMetaSection } from './components/OrderFormMetaSection';
import { OrderFormPaymentSection } from './components/OrderFormPaymentSection';
import { OrderFormShippingSection } from './components/OrderFormShippingSection';
import { TOrderForm, TOrderFormValues } from './OrderForm.types';
import './OrderForm.styled.scss';
import '../OrderDetail/OrderDetail.styled.scss';
import '../../../../AdminPanel.styles.scss';

export const OrderForm: TOrderForm = ({ onSubmit, mode }) => {
  const localize = useLocalize();
  const { handleSubmit } = useFormContext<TOrderFormValues>();

  return (
    <div className="admin-order-form admin-form">
      <form
        className="admin-form__form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="admin-form__form-content">
          <OrderFormMetaSection mode={mode} />
          <OrderFormPaymentSection />
          <OrderFormFlagsSection />
          <OrderFormShippingSection />
          <OrderFormLineItemsSection />
        </div>
        <div className="admin-form__actions">
          <Button variant="contained" type="submit">
            {localize('admin.orders.form.save')}
          </Button>
        </div>
      </form>
    </div>
  );
};
